import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { IFile } from '@model/file';

import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

import { actionItemCommentsKey } from './useActionItemCommentsQuery';

interface IData {
  comment: string;
  attachments: IFile[];
  type: string;
  action_item_id: string | number;
}

const commentSaveFn = (data: IData) =>
  apiClient.post(`${APP_API_URL_V2}fsd/action-item/${data.action_item_id}/comment`, data);

export const useCommentSaveMutation = ({ actionItemId }: { actionItemId: string | number }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: commentSaveFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
    },
  });
};
